module.exports = __webpack_public_path__ + "static/media/ic_flow_4.faff82f2.jpg";